import { usePage } from "@inertiajs/vue3";
import { usePreloadStore } from "@/Tailwind/Stores/preload";

export function useLocations() {
    const findLocationRecursive = (root, id) => {
        let result = null;
        root.forEach((node) => {
            if (node.id === id) {
                result = node;
                return;
            }

            if (node.children) {
                const childResult = findLocationRecursive(node.children, id);
                if (childResult) {
                    result = childResult;
                    return;
                }
            }
        });

        return result;
    };

    // Find the tenant (First level of hierarchy) that contains the location
    const findTenantForLocation = (locations, locationId) => {
        let tenant = null;
        locations.forEach((location) => {
            if (location.id === locationId) {
                tenant = location;
                return;
            }

            if (location.children) {
                const childResult = findLocationRecursive(
                    location.children,
                    locationId
                );
                if (childResult) {
                    tenant = location;
                    return;
                }
            }
        });

        return tenant;
    };

    const isTenant = (id) => {
        const tenants = usePage().props.auth.user.tenants;

        return tenants.some((tenant) => tenant.id === id);
    };

    const getLocationInformation = (locationId) => {
        let tenant = null;
        let allocationType = null;

        const preloadStore = usePreloadStore();
        let spaces = preloadStore.locations;

        const space = findLocationRecursive(spaces, locationId);

        if (space) {
            tenant = findTenantForLocation(spaces, locationId);
            allocationType = "spaces";
        } else {
            const assets = preloadStore.assets;
            const asset = findLocationRecursive(assets, locationId);

            if (asset) {
                tenant = findTenantForLocation(assets, locationId);
                allocationType = "assets";
            }
        }

        return {
            tenant,
            allocationType,
        };
    };

    const locationHasChild = (location, childId) => {
        let contains = false;

        if (location.id === childId) {
            contains = true;
        } else if (location.children) {
            const child = findLocationRecursive(location.children, childId);
            contains = !!child;
        }

        return contains;
    };

    return {
        isTenant,
        findLocationRecursive,
        findTenantForLocation,
        getLocationInformation,
        locationHasChild,
    };
}
